import React, { type ReactNode } from 'react';

import ErrorIcon from '@atlaskit/icon/core/error';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const errorMessageWrapperStyles = xcss({
	display: 'flex',
	alignItems: 'flex-start',
	gap: 'space.050',
});

const errorMessageTextStyles = xcss({
	font: 'font.body.UNSAFE_small',
	color: 'color.text.accent.red',
});

export const FormFieldErrorMessage = ({ children }: { children: ReactNode }) => (
	<Box xcss={errorMessageWrapperStyles}>
		<ErrorIcon label="" color={token('color.icon.accent.red')} />
		<Inline xcss={errorMessageTextStyles}>{children}</Inline>
	</Box>
);
